import { defineMessages } from 'react-intl';

const messages = {
  deepintegration:
    defineMessages({
      headerDefaultReview: {
        id: '',
        description: 'Dropbox header for Review',
        defaultMessage: 'Does everything look right?',
      },
    }),
};

export default messages;
